import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import MoveIcon from '@learningblocks/exp-constants/lib/Images/move_icon.svg';
import './style.scss';

/**
 * SlideOneOption: Option component associated with DesignSection
 * first slide [verify-snp-sequence]
 */

export function SlideOneOption(props) {
  return (
    <div className='slideOneOption'>
      <Image src={MoveIcon} alt='movecardIcon' onClick={props.addCard} />
      <p>{props.text}</p>
    </div>
  );
}

SlideOneOption.propTypes = {
  /**
   * Function to invoke when SetAsNext Button is clicked
   */
  addCard: PropTypes.func,
  /**
   * Text to be displayed in Card.
   */
  text: PropTypes.string,
};

SlideOneOption.defaultProps = {
  text: '',
};


